import { Control, FieldError } from "react-hook-form"
import Input from "~app/Input"
import { FormField, FormFieldType } from "~shapes/dynamicForm"
import { ERROR_MESSAGES } from "~constants/errorMessages"
import DatePicker from "~app/DatePicker"
import ControlSelect from "~app/ControlSelect"

interface Props {
  field: FormField
  control: Control
  errors: FieldError
  register: any
  getValues: any
  setValue: any
  unregister: any
}

const InputGenerator = ({
  field,
  control,
  errors,
  register,
  getValues,
  setValue,
  unregister,
}: Props) => {
  switch (field.input_type) {
    case FormFieldType.TEXT:
      return (
        <Input
          key={field.input_key}
          name={field.input_key}
          label={field.input_name}
          register={register(field.input_key, {
            required: field.required,
            pattern: {
              value: field.input_regex,
              message: field.error_prompt,
            },
          })}
          errorMessage={
            errors[field.input_key] &&
            (errors[field.input_key].message || ERROR_MESSAGES.FIELD_REQUIRED)
          }
        />
      )
    case FormFieldType.DATE:
      return (
        <DatePicker
          name={field.input_key}
          label={field.input_name}
          errorMessage={
            errors[field.input_key] && ERROR_MESSAGES.FIELD_REQUIRED
          }
          required={field.required}
          {...{ register, setValue, getValues, unregister }}
        />
      )
    case FormFieldType.SELECT:
      return (
        <ControlSelect
          name={field.input_key}
          label={field.input_name}
          rules={{ required: field.required }}
          height={200}
          control={control}
          options={field.options!.map(option => ({
            label: option.label,
            value: option.value,
          }))}
          errorMessage={
            errors[field.input_key] && ERROR_MESSAGES.FIELD_REQUIRED
          }
        />
      )
  }
}

export default InputGenerator
